import { render, staticRenderFns } from "./ChildDeviceTable.vue?vue&type=template&id=37c5ac39&scoped=true"
import script from "./ChildDeviceTable.vue?vue&type=script&lang=ts"
export * from "./ChildDeviceTable.vue?vue&type=script&lang=ts"
import style0 from "./ChildDeviceTable.vue?vue&type=style&index=0&id=37c5ac39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5ac39",
  null
  
)

export default component.exports